import { render, staticRenderFns } from "./FeeSettingsSetup.vue?vue&type=template&id=28eaa939&"
import script from "./FeeSettingsSetup.vue?vue&type=script&lang=js&"
export * from "./FeeSettingsSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports